import React, { useEffect, useState } from 'react'

// Libraries
import { Col, Container, Row } from 'react-bootstrap'
import { Parallax } from 'react-scroll-parallax'
import { m } from "framer-motion";

// Components
import { fadeIn } from '../../Functions/GlobalAnimations';
import axios from 'axios';
import Markdown from "react-markdown";
import gfm from "remark-gfm";
import config from '../../config';

const APropos = (props) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const fidPageAprops = async () => {
    try {
      // eslint-disable-next-line no-undef
      await axios.get(`${config.REACT_APP_API_URL}/page_aprops`,{
            headers: { 
            'x-api-key': config.SITE_API_KEY
           }}).then((response) => {
        setTitle(response.data.title);
        setDescription(response.data.description);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fidPageAprops();
  }, []);
  return (
    <div className="who-we-are" style={props.style}>
      {/* Parallax Scrolling Start */}
             <m.div className="h-[380px] overflow-hidden sm:h-[200px] relative" {...fadeIn}>
                                  <Parallax 
                                      className="lg-no-parallax bg-cover absolute top-0 left-0 w-full h-full" 
                                      translateY={[-40, 40]} 
                                      style={{ backgroundImage: `url(/assets/img/webp/portfolio-bg.webp)` }}
                                  />
                                  <Container className="h-full relative">
                                      <Row className="items-stretch justify-center h-[450px] md:h-[375px] sm:h-[275px]">
                                          <Col xl={6} lg={7} md={8} xs={12} className="text-center flex justify-center flex-col">
                                              <h2 className="text-darkgray mb-[0px] font-serif font-medium -tracking-[1px] xs:mb-[0px]">À Propos</h2>
                                          </Col>
                                      </Row>
                                  </Container>
                              </m.div>
            {/* Parallax Scrolling End */}

      {/* Section Start */}
      <m.section className="py-[30px]" {...fadeIn}>
        <Container>
          <Row className="items-center">
            <Col xl={5} lg={6} className="pb-12 lg:pb-28 sm:pb-[50px]">
              <div className="text-xmd mb-[20px] font-serif">À propos SPEED TUNISA</div>
              <h5 className="font-serif text-darkgray font-medium">Nous avons 10 ans d'expérience pratique</h5>
              <p className="font-serif font-medium mb-[3rem]">
                <Markdown remarkPlugins={[gfm]}>{description}</Markdown>
              </p>
              <Row>
                <Col>
                  <div className="flex">
                    <div className="mr-[35px]">
                      <i className="line-icon-Idea-5 text-[50px] text-[#558927]"></i>
                    </div>
                    <div className="feature-box-content ">
                      <span className="text-darkgray block font-serif font-medium">
                        SERVICE-PROCESS-EQUIPEMENT-EXPRESS-DISTRIBUTION
                      </span></div>
                  </div>
                </Col>
                <Col className="col-12"><div className="h-[1px] bg-[#ededed] my-[40px] w-full xs:my-[30px]"></div></Col>
                <Col>
                  <div className="flex">
                    <div className="mr-[35px]">
                      <i className="line-icon-Medal-2 text-[50px] text-[#558927]"></i>
                    </div>
                    <div className="feature-box-content ">
                      <span className="text-darkgray block font-serif font-medium">
                        MATIERE PREMIERES POUR LES INDUSTRIES ALIMENTAIRES
                        </span></div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={6} xl={{ offset: 1 }} className="align-self-end text-center text-xl-start">
              <img className="md:mx-auto" loading="lazy" src="/img/SPEED2-1024x746.jpg" width="800" height="800" alt="who-we-are"
              style={{ boxShadow: "20px 20px 20px rgba(0, 0, 0, 0.4)" }} />
            </Col>
          </Row>
        </Container>
      </m.section>
      {/* Section End */}
    </div>
  )
}

export default APropos